import React from "react";


import {hasAuthParams, useAuth} from "react-oidc-context";
import {useNavigate} from "react-router-dom";
import {
  LS_USER_INFO, LS_USER_PHOTO,
  ROLE_CA_DATA_MANAGER,
  ROLE_CA_END_USER,
  ROLE_ESA_END_USER,
  ROLE_FUNC_ADMIN
} from "../../constants/EiopaFnPConstants";
import {FnPUser} from "../../model/FnPUser";
import {clearUserInfo, getUserInfo} from "../../services/UserInfoService";

function Login() {


  const auth = useAuth();
  const navigate = useNavigate();
  // Use a ref instead of state to prevent re-renders
  const redirectInProgressRef = React.useRef(false);

  React.useEffect(() => {
    // Prevent multiple redirects
    if (redirectInProgressRef.current) {
      return;
    }

    if (!hasAuthParams() &&
        !auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading
    ) {
      clearUserInfo();
      localStorage.removeItem(LS_USER_PHOTO);
      redirectInProgressRef.current = true;
      auth.signinRedirect();
    } else if (auth.isAuthenticated && auth.user) {
      let userInfo = getUserInfo(auth.user.id_token);
      if (!userInfo.roles || userInfo.roles.length === 0) {
        // If userInfo.roles is empty, clear user info and redirect to login
        clearUserInfo();
        localStorage.removeItem(LS_USER_PHOTO);
        redirectInProgressRef.current = true;
        auth.signinRedirect();
        return;
      }
      if(userInfo.roles.includes(ROLE_CA_END_USER) || userInfo.roles.includes(ROLE_ESA_END_USER)) {
        navigate("/view-requests");
        return;
      }
      if(userInfo.roles.includes(ROLE_CA_DATA_MANAGER)) {
        navigate("/manage-system-data/poi-list");
        return;
      }
      if(userInfo.roles.includes(ROLE_FUNC_ADMIN)) {
        navigate("/admin/eu-sec-leg-bases");
        return;
      }
    } else if (auth.isLoading) {
      // Do nothing while loading
      return;
    } else {
      // If we have OIDC context but not authenticated, clear and redirect
      clearUserInfo();
      localStorage.removeItem(LS_USER_PHOTO);
      redirectInProgressRef.current = true;
      auth.signinRedirect();
    }
  }, [auth.isAuthenticated, auth.isLoading, auth.activeNavigator, auth.user]);

  return (
      <p>Please login....</p>
  )
}



export default Login;
